import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { HorsesShareEffects } from './effects/horses-share.effects';
import * as HorseShareReducers from './reducers/horses-share.reducer';
import { HorseShareService } from './services/horse-share.service';
import { HorsesShareStoreFacade } from './facades/horses-share-store.facade';
import { AuthService } from '../auth-store';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      HorseShareReducers.horsesShareFeatureKey,
      HorseShareReducers.reducer
    ),
    EffectsModule.forFeature([HorsesShareEffects]),
  ],
  providers: [HorseShareService, HorsesShareStoreFacade, AuthService],
})
export class HorsesShareStoreModule {}
